import { render, staticRenderFns } from "./TagStatus.vue?vue&type=template&id=7cd0d8e0&scoped=true"
import script from "./TagStatus.vue?vue&type=script&lang=js"
export * from "./TagStatus.vue?vue&type=script&lang=js"
import style0 from "./TagStatus.vue?vue&type=style&index=0&id=7cd0d8e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd0d8e0",
  null
  
)

export default component.exports